<div class="splash-screen">
  <div class="splash-screen-header">
    <img class="cc-logo" src="assets/images/cc-logo.png" />
  </div>
  <div class="loading-message">
    <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
    <br />
    <h3>Loading...</h3>
  </div>
</div>
